import { array, nullable, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as OrganizationId } from '../../organization/Id';

export const FilterRequest = struct({
	organizations: nullable(array(OrganizationId)),
	sentAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
});
